import { createContext, useContext, useEffect, useState } from 'react'
import { getCurrentUser, onAuthStateChange, signOut as hubSignOut } from '@/services/auth-supabase'

const HubAuthContext = createContext(null)

export function useHubAuth() {
  const ctx = useContext(HubAuthContext)
  if (!ctx) throw new Error('useHubAuth must be used within HubAuthProvider')
  return ctx
}

export function HubAuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getCurrentUser().then(setUser).finally(() => setLoading(false))
    const { data: { subscription } } = onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
    })
    return () => subscription?.unsubscribe()
  }, [])

  const signOut = async () => {
    await hubSignOut()
    setUser(null)
  }

  return (
    <HubAuthContext.Provider value={{ user, loading, isAuthenticated: !!user, signOut }}>
      {children}
    </HubAuthContext.Provider>
  )
}
